import { Component, OnInit } from '@angular/core'
import { WhoSubmitter } from './who-submit.service'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'

@Component({
  selector: 'se-po-household-setup-whos-participating',
  templateUrl: './who.component.html',
  styleUrls: ['./who.component.scss'],
})
export class WhoComponent implements OnInit {
  public footerYear = new Date().getFullYear()
  public ready = false

  constructor(
    public setupBarService: SetupBarService,
    public submitter: WhoSubmitter,
  ) {
    // no-op
  }

  public ngOnInit(): void {
    // todo get context from queryParams
    // save context to localStorage?
    this.ready = true
    this.setupBarService.percentComplete = 0
  }
}
